<template>
  <SysDirCommon :dir-name="'使用帮助目录'" :dir-def-id="'sys_help'" :isPdf="true"></SysDirCommon>
</template>

<script>

import SysDirCommon from "@/views/applications/sys/SysDirCommon.vue";
export default {
  name: "HelpCatalogConfig",
  components: {SysDirCommon},
  data() {
    return {}
  },
  provide() {
    return {
      $fn: {}
    }
  },
  methods: {},
  created() {}
}
</script>

<style lang="less" scoped>
@import 'src/global';
</style>